import { ChangeDetectorRef, Directive } from '@angular/core';
import { CdRefreshService } from '../services/cd-refresh.service';

@Directive({ selector: 'mat-sidenav-content', standalone: false })
export class SidenavCdRefreshDirective {
    constructor(cdr: ChangeDetectorRef, cdRefreshService: CdRefreshService) {
        cdRefreshService.register(cdr);
    }
}
